/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { __ } from '@googleforcreators/i18n';

export const DEFAULT_POPUP_FILL_WIDTH = 276;
export const DEFAULT_PLACEHOLDER = __('Search', 'web-stories');
export const DEFAULT_ARIA_CLEAR_LABEL = __('Clear Search', 'web-stories');
export const DEFAULT_ARIA_INPUT_LABEL = __('Search', 'web-stories');

export const Z_INDEX = {
  CLEAR_BUTTON: 5,
};
